function getKeyMonitorList () {
  return [
    {
      name: '烧结落地矿料场',
      position: '119.4503382448475_34.609378188510483_183.197067_-338.518921_7.599988'
    },
    {
      name: '烧结焦粉棚',
      position: '119.45110615651191_34.608031511617554_81.42521_-63.61876_30.8000145'
    },
    {
      name: '烧结落地矿料场',
      position: '119.44589975310106_34.606450961235048_65.6064148_-482.2188_23.3000011'
    },
    {
      name: '烧结3#煤棚"',
      position: '119.44859728049826_34.60769584699046_286.641785_-480.4188_10.6999941'
    },
    {
      name: '烧结镍矿大棚',
      position: '119.45452945468887_34.609147263881127_316.447723_-5.1097455_4.4'
    },
    {
      name: '高炉喷煤料棚',
      position: '119.45110615651191_34.608031511617554_81.42521_-63.61876_30.8000145'
    },
    {
      name: '高炉焦炭棚',
      position: '119.44613942804928_34.607999493987975_82.00931_-336.018768_26.8000031'
    },
    {
      name: '竖窑石灰窑棚',
      position: '119.44878814671705_34.608787372190747_45.0_-487.5188_17.9000015'
    },
  ]
}
export {getKeyMonitorList}
